// Statut d'une lettre: "correct", "present", "absent", "given"

export function evaluateGuess(solution, guess) {
    const len = solution.length;
    const result = new Array(len).fill("absent");
    const solChars = solution.split("");
    const guessChars = guess.split("");
  
    const used = new Array(len).fill(false);
  
    // 1 : lettres bien placées
    for (let i = 0; i < len; i++) {
      if (guessChars[i] === solChars[i]) {
        result[i] = "correct";
        used[i] = true;
      }
    }
  
    // 2 : lettres présentes mal placées
    for (let i = 0; i < len; i++) {
      if (result[i] === "correct") continue;
      const ch = guessChars[i];
      let found = false;
      for (let j = 0; j < len; j++) {
        if (!used[j] && solChars[j] === ch) {
          used[j] = true;
          found = true;
          break;
        }
      }
      if (found) {
        result[i] = "present";
      }
    }
  
    return result;
  }
  
  export function updateKeyboardState(currentState, guess, statuses) {
    const newState = { ...currentState };
    for (let i = 0; i < guess.length; i++) {
      const ch = guess[i];
      const st = statuses[i];
      const prev = newState[ch];
      if (!prev) {
        newState[ch] = st;
        continue;
      }
      if (prev === "correct") continue;
      if (prev === "present" && st === "absent") continue;
      if (st === "correct") {
        newState[ch] = "correct";
      } else if (st === "present" && prev === "absent") {
        newState[ch] = "present";
      }
    }
    return newState;
  }
  